function getOrgName(): string {
  return (process.env && process.env.VUE_APP_ORG_NAME) || "";
}
function getOrgInn(): string {
  return (process.env && process.env.VUE_APP_ORG_INN) || "";
}
function getOrgAddress(): string {
  return (process.env && process.env.VUE_APP_ORG_ADDRESS) || "";
}
function getOrgEmail(): string {
  return (process.env && process.env.VUE_APP_ORG_EMAIL) || "";
}
function getBaseUrl(): string {
  return (process.env && process.env.VUE_APP_BASE_URL) || "";
}

export {
  getOrgName,
  getOrgInn,
  getOrgAddress,
  getOrgEmail,
  getBaseUrl,
};
